<template>
  <div>
    <div v-if="isMe && $store.state.edit.on">
      <div v-for="({ txt, descr, isSelected }, key) in projectSizes" :key="key" class="row">
        <div class="col-sm-6">
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <input-checkbox
            :checked="isSelected"
            :name="'project-size[]'"
            :model-value="key"
            :disabled="isSelected && numberOfSelected < 2"
            @change="handleSelectionChange"
          >
            {{ $t(txt) }}
          </input-checkbox>
          &nbsp;
          <span :title="$t(descr)" class="c-indigo-500" data-toggle="tooltip">
            <i class="zmdi zmdi-help" />
          </span>
        </div>
        <div class="col-sm-6 m-h-20" style="margin-top: -15px">
          <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
          <NetworkLoader
            :loader="latestClickedItemKey == key && saving"
            :failed="latestClickedItemKey == key && saveFailed"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <!-- eslint-disable-next-line vue/no-v-for-template-key -- Baseline eslint ignore please fix if working on this-->
      <template v-for="projectSize in projectSizes" :key="projectSize.txt">
        <div v-if="projectSize.isSelected">
          <i class="zmdi zmdi-assignment-check f-18 c-gray-900" />
          &nbsp;
          {{ $t(projectSize.txt) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import enums from '@/utils/enum'
import { SET_EDIT_UNSAVED, UPDATE_USER_STATE } from '@/state/mutation-types'
import { SET_EDIT_SAVING_STATE } from '@/state/action-types'
import { UPDATE_FREELANCER } from '@/state/apollo/accounts'
import { NetworkError } from '@/utils/notification'

export default {
  name: 'ComponentEditProjectSize',
  props: {
    isMe: {
      type: Boolean,
      required: true,
    },
    associations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      saveFailed: false,
      projectSizes: [],
      latestClickedItemKey: 0,
    }
  },
  computed: {
    numberOfSelected() {
      return this.projectSizes.filter((item) => item.isSelected).length
    },
  },
  watch: {
    saving(saving) {
      this.$store.dispatch(SET_EDIT_SAVING_STATE, saving)
    },
  },
  created() {
    this.projectSizes = this.associations
  },
  methods: {
    handleSelectionChange(fieldValue, isChecked) {
      this.latestClickedItemKey = fieldValue
      this.projectSizes[fieldValue].isSelected = isChecked
      this.saveChanges()
    },
    async saveChanges() {
      this.saveFailed = false
      this.saving = true
      try {
        this.$store.commit(SET_EDIT_UNSAVED, true)
        const projectSizesState = this.projectSizes
          .filter((projectSize) => projectSize.isSelected)
          .map((projectSize) => projectSize.name)

        await this.$apollo.mutate({
          mutation: UPDATE_FREELANCER,
          variables: {
            input: {
              globalId: this.account.globalId,
              associations: projectSizesState,
            },
          },
        })

        this.$store.commit(UPDATE_USER_STATE, {
          fieldName: 'projectsizes',
          fieldValue: projectSizesState,
        })
        this.$store.commit(SET_EDIT_UNSAVED, false)
      } catch (e) {
        this.$store.commit(SET_EDIT_UNSAVED, true)
        this.saveFailed = true
        new NetworkError({
          severity: enums.notification.severity.CRITICAL,
          ex: e,
        }).dispatch(this)
      }
      this.saving = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
